<template>
  <div>
    <c-card title="기본 정보" class="cardClassDetailForm">
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-text
            :editable="false"
            label="점검년월"
            type="month"
            name="checkMonth"
            v-model="popupParam.checkMonth"
          >
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-dept
            :editable="false"
            label="점검부서"
            name="upDeptCd"
            v-model="popupParam.upDeptCd"
            @setDeptName="(_deptName) => popupParam.upDeptName = _deptName"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-field
            :editable="false"
            type="dept_user"
            label="점검자"
            name="regUserId"
            v-model="checkData.regUserId"
          />
        </div>
      </template>
    </c-card>
    <c-table
      ref="table"
      title="반별/주차별 체크리스트"
      class="table_vt_middle"
      :merge="grid.merge"
      :columns="grid.columns"
      :data="grid.data"
      :editable="editable && esfSenior"
      :usePaging="false"
      gridHeightAuto
      @table-data-change="tableDataChange"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <!--삭제-->
          <c-btn
            v-if="editable && esfSenior"
            label="LBLREMOVE"
            icon="close"
            @btnClicked="deleteChecklist" />
          <!--저장-->
          <c-btn
            v-if="editable && (esfSenior || isEnvSafDept && Boolean(checkData.supervisorChecklistId))"
            :isSubmit="isSave"
            :url="saveUrl"
            :param="saveParam"
            mappingType="PUT"
            label="LBLSAVE"
            icon="save"
            @beforeAction="saveChecklist"
            @btnCallback="saveCallback" />
        </q-btn-group>
      </template>
      <!-- 환경안전팀 의견: isEnvSafDept 권한자만 작성 가능 -->
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name === 'opinion'">
          <c-textarea-column
            :editable="editable && isEnvSafDept && Boolean(checkData.supervisorChecklistId)"
            :col="col"
            :props="props"
            @datachange="datachange(props.row)"
          />
        </template>
      </template>
    </c-table>
    <c-upload
      class="q-pt-xl"
      :attachInfo="attachInfo"
      :editable="editable && esfSenior"
      label="파일첨부">
    </c-upload>
  </div>
</template>

<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'supervisor-checklist-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        checkMonth: '',
        upDeptCd: '',
        upDeptName: ''
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      checkData: {
        supervisorChecklistId: '',
        upDeptName: '',
        upDeptCd: null,
        checkMonth: null,
        regUserId: null,
      },
      deptColNames: [], // 반(하위부서) 코드 목록 - 그리드의 동적 컬럼명과 동일
      grid: {
        merge: [],
        columns: [
          {
            name: 'weekLabel',
            field: 'weekLabel',
            label: '점검주차',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
        ],
        data: [],
      },
      editable: true,
      esfSenior: false,
      isSave: false,
      saveUrl: '',
      deleteUrl: '',
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'SUPERVISOR_CHECKLIST',
        taskKey: '',
      },
    };
  },
  computed: {
    // 저장 시 화면에 평탄화(flat)되어 있던 반별 체크값을 다시 weekList/deptList 구조로 조립한다.
    saveParam() {
      return {
        supervisorChecklistId: this.checkData.supervisorChecklistId,
        checkMonth: this.popupParam.checkMonth,
        upDeptCd: this.popupParam.upDeptCd,
        regUserId: this.checkData.regUserId,
        chgUserId: this.$store.getters.user.userId,
        weekList: this.$_.map(this.grid.data, row => {
          return {
            supervisorChecklistWeekId: row.supervisorChecklistWeekId,
            weekNo: row.weekNo,
            remark: row.remark,
            opinion: row.opinion,
            deptList: this.$_.map(this.deptColNames, deptCd => {
              return {
                supervisorChecklistWeekId: row.supervisorChecklistWeekId,
                deptCd: deptCd,
                receiveFlag: row[deptCd],
              };
            }),
          };
        }),
      };
    },
    isEnvSafDept() {
      return (
        this.$_.indexOf(this.$store.getters.auths, "SAGI000027") > -1
        //  || this.$store.getters.user.userId === "U000000001"
      );
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.saveUrl = transactionConfig.sup.checklist.save.url;
      this.deleteUrl = transactionConfig.sup.checklist.delete.url;
      // list setting (반 목록 조회 -> 주차 행 생성 -> 실제 저장값 조회 순으로 체이닝)
      this.$http.url = selectConfig.mdm.senior.status.list.url;
      this.$http.type = 'GET';
      this.$http.param = {
        seniorId: 'MSI0000012',
        deptCd: this.popupParam.upDeptCd,
        dismissalFlag: 'N'
      };
      this.$http.request((_result) => {
        this.esfSenior = (_result.data || []).some(item => item.seniorUserId === this.$store.getters.user.userId)
        if (this.esfSenior && !this.checkData.regUserId) this.checkData.regUserId = this.$store.getters.user.userId;
      },)
      this.getTeamDepts();
    },
    // 헤더가 이미 저장돼 있으면 조회, 없으면(아직 한 번도 저장 안 한 신규) 화면에만 기본값을 채운다.
    // 헤더/주차/반별 로우는 실제로 저장(saveChecklist) 버튼을 눌러야만 DB에 생성된다.
    getDetail() {
      this.$http.url = selectConfig.sup.checklist.cell.url;
      this.$http.type = 'GET';
      this.$http.param = {
        checkMonth: this.popupParam.checkMonth,
        upDeptCd: this.popupParam.upDeptCd,
      };
      this.$http.request((_result) => {
        if (_result.data) {
          this.checkData = this.$_.clone(_result.data);
          this.$emit('setRegInfo', _result.data);
          this.$set(this.attachInfo, 'taskKey', _result.data.supervisorChecklistId);

          let weekByNo = this.$_.keyBy(_result.data.weekList, 'weekNo');
          this.$_.forEach(this.grid.data, row => {
            let week = weekByNo[row.weekNo];
            if (!week) return;
            row.supervisorChecklistWeekId = week.supervisorChecklistWeekId;
            row.remark = week.remark;
            row.opinion = week.opinion;
            let deptByCd = this.$_.keyBy(week.deptList, 'deptCd');
            this.$_.forEach(this.deptColNames, deptCd => {
              row[deptCd] = deptByCd[deptCd] ? deptByCd[deptCd].receiveFlag : 'N';
            });
          });
        } else {
          this.checkData.supervisorChecklistId = '';
          this.checkData.checkMonth = this.popupParam.checkMonth;
          this.checkData.upDeptCd = this.popupParam.upDeptCd;
          // this.checkData.regUserId = this.esfSenior ? this.$store.getters.user.userId : null;
        }
      },);
    },
    // 열(반): 체크리스트의 upDeptCd로 백엔드 getDepts를 조회한 하위부서 목록을 그대로 컬럼으로 사용한다.
    getTeamDepts() {
      this.$http.url = selectConfig.mdm.dept.list.url;
      this.$http.type = 'GET';
      this.$http.param = {
        upDeptCd: this.popupParam.upDeptCd,
        useFlag: 'Y',
      };
      this.$http.request((_result) => {
        let deptCols = this.$_.map(_result.data, dept => {
          return {
            name: dept.deptCd,
            field: dept.deptCd,
            label: dept.deptName,
            align: 'center',
            style: 'width:90px',
            sortable: false,
            type: 'check',
            true: 'Y',
            false: 'N',
          };
        });
        // 첫 번째 컬럼(상위부서 자신)은 백엔드 조회쿼리에서 이미 포함해서 내려주므로 deptCols[0]이 곧 그 컬럼이다.
        // 주차와 무관하게 값이 하나이므로 세로 병합해서 한 칸으로 보여준다.
        this.deptColNames = this.$_.map(deptCols, 'name');
        this.grid.merge = deptCols.length > 0 ? [{ index: 1, colName: deptCols[0].name }] : [];
        this.grid.columns = [
          this.grid.columns[0],
          ...deptCols,
          {
            name: 'remark',
            field: 'remark',
            label: '특이사항(ESF담당자)',
            align: 'left',
            style: 'width:220px',
            sortable: false,
            type: 'textarea',
          },
          {
            name: 'opinion',
            field: 'opinion',
            label: '환경안전팀 의견',
            align: 'left',
            style: 'width:220px',
            sortable: false,
            type: 'custom',
          },
        ];
        this.buildWeekRows();
        this.getDetail();
      },);
    },
    // 행(주차): 공통함수 getWeekCountOfMonth로 선택한 점검월의 주차 수만큼 행을 만든다.
    buildWeekRows() {
      let weekCount = this.$comm.getWeekCountOfMonth(this.popupParam.checkMonth);
      let [year, month] = this.popupParam.checkMonth.split('-');
      let rows = [];
      for (let weekNo = 1; weekNo <= weekCount; weekNo++) {
        let row = {
          weekNo: weekNo,
          weekLabel: `${year}년 ${month}월 ${weekNo}주차`,
          remark: '',
          opinion: '',
        };
        this.$_.forEach(this.deptColNames, deptCd => {
          row[deptCd] = 'N';
        });
        rows.push(row);
      }
      this.grid.data = rows;
    },
    saveChecklist() {
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',
        message: 'MSGSAVE',
        type: 'info',
        confirmCallback: () => {
          this.isSave = !this.isSave;
        },
        cancelCallback: () => {},
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      if (!this.checkData.supervisorChecklistId) {
        // 최초 저장으로 방금 헤더가 새로 생성된 경우: 저장 전 임시 taskKey로 올려둔 첨부파일을 실제 supervisorChecklistId로 옮겨붙인다.
        this.checkData.supervisorChecklistId = result.data;
        this.$set(this.attachInfo, 'taskKey', result.data);
        this.$set(this.attachInfo, 'isSubmit', uid());
      }
      this.getDetail();
    },
    deleteChecklist() {
      if (!this.checkData.supervisorChecklistId) {
        // 아직 한 번도 저장 안 한 신규: 지울 데이터가 없으므로 그냥 닫는다.
        this.$emit('closePopup');
        return;
      }
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',
        message: 'MSGREMOVE',
        type: 'info',
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.checkData.supervisorChecklistId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup');
          },);
        },
        cancelCallback: () => {},
      });
    },
    datachange(row) {
      if (row["editFlag"] !== "C") {
        row["editFlag"] = "U";
        row["chgUserId"] = this.$store.getters.user.userId;
      }
    },
    // 상위부서 컬럼(첫 번째 반 컬럼)은 주차 행 전체가 병합되어 한 칸으로 보이므로, 값이 바뀌면 모든 주차 행에 동일하게 반영해야 병합 상태와 저장값이 일치한다.
    tableDataChange(props, col) {
      if (col.name !== this.deptColNames[0]) return;
      let value = props.row[col.name];
      this.$_.forEach(this.grid.data, row => {
        this.$set(row, col.name, value);
        this.datachange(row);
      });
    },
  },
};
</script>
<style lang="sass">
.supervisor-checklist-header
  padding: 10px 14px
  font-size: 1rem
</style>
